<script setup lang="ts">
</script>

<template>
  <app-button type="submit">
    <slot></slot>
  </app-button>
</template>
